<template>
  <publicImport :importTypeList="importTypeList"></publicImport>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import publicImport from "@/components/common/publicImport";
import {setConfigCharacters} from "@/utils/common";


export default {
  name: "importTask",
  data() {
    return {
      importTypeList: [
        {value: 'ymsPackageInfoImport', name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')}`},
        {value: 'ymsProductGoodsMappingType', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005611')},
        {value: 'ymsProductGoodsRelationType', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005612')},
      ]
    };
  },
  components: {
    publicImport
  }
};
</script>

<style scoped>

</style>
